import { render, staticRenderFns } from "./UCAppHeaderItem.vue?vue&type=template&id=407ef72b&scoped=true&"
import script from "./UCAppHeaderItem.vue?vue&type=script&lang=ts&"
export * from "./UCAppHeaderItem.vue?vue&type=script&lang=ts&"
import style0 from "./UCAppHeaderItem.vue?vue&type=style&index=0&id=407ef72b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407ef72b",
  null
  
)

export default component.exports